// extracted by mini-css-extract-plugin
module.exports = {"mobile-layout-header":"header_mobile-layout-header_188KY","mobile-layout_language":"header_mobile-layout_language_1qyHr"};